<template>
    <div>
        <Drawer 
            v-model="innerVisible" 
            :title="title" 
            width="900"
            :mask-closable="true"
            :styles="drawerStyles"
        >
            <div class="material-container">
                <!-- 左侧分类 -->
                <div class="category-sidebar">
                    <div class="material-source-switch">
                        <RadioGroup v-model="materialSource" type="button" @on-change="handleSourceChange">
                            <!-- <Radio label="org">
                                <Icon type="ios-business" />
                                <span>机构素材</span>
                            </Radio> -->
                            <Radio label="platform">
                                <Icon type="ios-globe" />
                                <span>平台素材</span>
                            </Radio>
                        </RadioGroup>
                    </div>
                    <div class="category-header">
                        <h3>素材分类</h3>
                    </div>
                    <div class="category-list">
                        <div 
                            v-for="(tab, index) in tabs" 
                            :key="index"
                            class="category-item"
                            :class="{ active: activeTab === tab.name }"
                            @click="changeTab(tab.name)"
                        >
                            <Icon :type="tab.icon" />
                            <span>{{ tab.label }}</span>
                        </div>
                    </div>
                </div>

                <!-- 右侧内容区 -->
                <div class="content-area">
                    <div class="filter-bar">
                        <Input v-model="search" placeholder="搜索文件名" style="width: 200px;" />
                        <Select v-model="sourceTypeSearch" placeholder="选择或输入文件分类" style="width: 200px; margin-left: 10px;" clearable filterable allow-create>
                            <Option v-for="item in sourceTypeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                        </Select>
                        <Button type="primary" @click="fetchMaterials(activeTab)" style="margin-left: 10px">搜索</Button>
                        <div style="display: inline-block; margin-left: 10px;">
                            <Button type="primary" icon="ios-cloud-upload-outline" @click="openUploadModal">上传{{ getCurrentTabLabel() }}</Button>
                        </div>
                    </div>
                    <div class="material-content">
                        <div class="material-list" :class="{ 'is-loading': loading }">
                            <div
                                v-for="(item, index) in materialList"
                                :key="index"
                                class="material-item"
                                :class="{ 'material-selected': isSelected(item) }"
                                @click="toggleSelect(item)"
                            >
                                <div class="material-preview" :class="`${activeTab}-preview`">
                                    <div class="file-type-tag">{{ getFileTypeLabel(item.filePath) }}</div>
                                    <div class="source-type-tag">{{ item.sourceType }}</div>
                                    <div class="material-checkbox">
                                        <Checkbox :value="isSelected(item)" @on-change="(checked) => toggleSelect(item)"></Checkbox>
                                    </div>
                                    <template v-if="isImageFile(item.filePath)">
                                        <img :src="item.fileUrl || item.filePath" alt="图片预览" />
                                    </template>
                                    <template v-else-if="isVideoFile(item.filePath)">
                                        <div class="video-preview">
                                            <img :src="getVideoThumbnail(item.fileUrl || item.filePath)" alt="视频预览" />
                                            <div class="video-play-icon">
                                                <Icon type="ios-play" size="30" />
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="isAudioFile(item.filePath)">
                                        <div class="audio-preview">
                                            <Icon type="ios-musical-notes" size="40" />
                                            <audio :src="item.fileUrl || item.filePath" controls></audio>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="file-preview">
                                            <Icon :type="getFileIconType(item.filePath)" size="40" />
                                            <span class="file-extension">{{ getFileExtension(item.filePath) }}</span>
                                        </div>
                                    </template>
                                </div>
                                <div class="material-info">
                                    <p class="material-name" :title="item.fileName" v-if="!item.isEditing">{{ item.fileName }}</p>
                                    <Input v-else v-model="item.editingName" size="small" @on-enter="saveFileName(item)" @on-blur="saveFileName(item)" />
                                    <div class="material-action">
                                        <Icon type="ios-eye-outline" @click.stop="previewMaterial(item)" title="预览" />
                                        <Icon type="ios-create-outline" @click.stop="editFileName(item)" title="修改名称" />
                                        <Icon type="ios-download-outline" @click.stop="downloadMaterial(item)" title="下载" />
                                        <Icon type="ios-trash-outline" @click.stop="deleteMaterial(item)" title="删除" />
                                    </div>
                                    <div class="material-size" v-if="item.fileSize">{{ formatFileSize(item.fileSize) }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="loading" class="loading-container">
                            <Spin fix>
                                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                                <div class="loading-text">加载中...</div>
                            </Spin>
                        </div>
                        <div class="material-empty" v-if="!loading && materialList.length === 0">
                            <Empty description="暂无素材" />
                        </div>
                    </div>
                    <div class="pagination">
                        <Page 
                            :total="total" 
                            :current="page" 
                            :page-size="pageSize" 
                            :page-count="maxPage"
                            @on-change="changePage" 
                            size="small" 
                            show-total 
                            show-elevator
                        />
                    </div>
                </div>
            </div>
            <div class="drawer-footer">
                <Button @click="onCancel" style="margin-right: 8px;">取消</Button>
                <Button type="primary" @click="handleSelectOk">确定</Button>
            </div>
            <Modal 
                v-model="previewVisible" 
                :title="previewItem ? previewItem.fileName : '预览'"
                footer-hide 
                fullscreen
                class="preview-modal"
            >
                <template v-if="previewItem && isImageFile(previewItem.filePath)">
                    <div class="preview-container">
                        <img :src="previewItem.fileUrl || previewItem.filePath" />
                    </div>
                </template>
                <template v-else-if="previewItem && isVideoFile(previewItem.filePath)">
                    <div class="preview-container">
                        <video :src="previewItem.fileUrl || previewItem.filePath" controls></video>
                    </div>
                </template>
                <template v-else-if="previewItem && isAudioFile(previewItem.filePath)">
                    <div class="preview-container">
                        <div class="audio-preview-modal">
                            <Icon type="ios-musical-notes" size="60" />
                            <audio :src="previewItem.fileUrl || previewItem.filePath" controls></audio>
                            <p class="preview-filename">{{ previewItem.fileName }}</p>
                        </div>
                    </div>
                </template>
                <template v-else-if="previewItem && isPdfFile(previewItem.filePath)">
                    <div class="preview-container">
                        <iframe :src="previewItem.fileUrl || previewItem.filePath"></iframe>
                    </div>
                </template>
                <template v-else-if="previewItem && isOfficeFile(previewItem.filePath)">
                    <div class="preview-container">
                        <div class="office-preview">
                            <Icon :type="getFileIconType(previewItem.filePath)" size="60" />
                            <p>{{ previewItem.fileName }}</p>
                            <p>Office 文件无法直接预览，请下载后查看。</p>
                            <Button type="primary" @click="downloadMaterial(previewItem)">下载文件</Button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="preview-container">
                        <div class="no-preview">
                            <Icon :type="getFileIconType(previewItem ? previewItem.filePath : '')" size="60" />
                            <p>{{ previewItem ? previewItem.fileName : '' }}</p>
                            <p>该文件类型不支持预览，请下载后查看。</p>
                            <Button type="primary" @click="downloadMaterial(previewItem)">下载文件</Button>
                        </div>
                    </div>
                </template>
            </Modal>
            <!-- 上传弹窗 -->
            <Modal
                v-model="uploadModalVisible"
                :title="'上传' + getCurrentTabLabel()"
                width="500"
                @on-ok="handleUploadOk"
                @on-cancel="handleUploadCancel"
            >
                <div class="upload-container">
                    <Form ref="uploadForm" :model="uploadForm" :rules="uploadRules" label-position="top">
                        <FormItem label="文件名称" prop="fileName">
                            <Input v-model="uploadForm.fileName" placeholder="请输入文件名称（包含后缀）" />
                        </FormItem>
                        <FormItem label="文件分类" prop="sourceType">
                            <Select v-model="uploadForm.sourceType" placeholder="请选择或输入文件分类" filterable allow-create @on-create="handleCreateCategory">
                                <Option v-for="item in sourceTypeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="文件大小" v-if="uploadForm.fileSize">
                            <span>{{ formatFileSize(uploadForm.fileSize) }}</span>
                        </FormItem>
                        <FormItem>
                            <LiefengUpload
                                target="1" 
                                :defaultList="val" 
                                ref="liefeng_upload"
                                :multiple="false"
                                :fileLength="1"
                                :accept="getAcceptByActiveTab()"
                                :format="getFormatByActiveTab()"
                                :showView="true"
                                @success="handleUploadSuccess"
                            />
                        </FormItem>
                    </Form>
                </div>
            </Modal>
            <!-- 添加编辑弹窗 -->
            <Modal
                v-model="editModalVisible"
                title="编辑文件信息"
                width="500"
                @on-ok="handleEditOk"
                @on-cancel="handleEditCancel"
            >
                <Form ref="editForm" :model="editForm" :rules="uploadRules" label-position="top">
                    <FormItem label="文件名称" prop="fileName">
                        <Input v-model="editForm.fileName" placeholder="请输入文件名称（包含后缀）" />
                    </FormItem>
                    <FormItem label="文件分类" prop="sourceType">
                        <Select v-model="editForm.sourceType" placeholder="请选择或输入文件分类" filterable allow-create @on-create="handleCreateCategory">
                            <Option v-for="item in sourceTypeList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Form>
            </Modal>
        </Drawer>
    </div>
</template>

<script>
import LiefengUpload from './LiefengUpload.vue'

export default {
    name: 'MaterialLibrary',
    components: {
        LiefengUpload
    },
    props: {
        // 是否可见
        value: {
            type: Boolean,
            default: false
        },
        // 是否支持多选
        multiple: {
            type: Boolean,
            default: false
        },
        // 指定素材类型，可以是 'image', 'video', 'file'，不指定则默认图片
        fileType: {
            type: String,
            default: 'image'
        },
        // 分组ID
        groupId: {
            type: [String, Number],
            default: '10001'
        },
        // 抽屉标题
        title: {
            type: String,
            default: '素材库'
        },
        // 最大选择数量
        maxSelect: {
            type: Number,
            default: 0
        },
        // 是否只允许选择特定类型
        allowedTypes: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            val:[],
            innerVisible: this.value,
            activeTab: 'image',
            search: '',
            sourceTypeSearch: '', // 新增文件分类搜索
            materialList: [],
            selectedItems: [], // 确保初始化为空数组
            page: 1,
            pageSize: 100,
            total: 0,
            maxPage: 1,
            previewVisible: false,
            previewItem: null,
            uploadModalVisible: false,
            editModalVisible: false, // 新增编辑弹窗控制
            editForm: { // 新增编辑表单
                fileId: '',
                fileName: '',
                sourceType: ''
            },
            uploadUrl: '/old/api/pc/fileUpload/upload',
            orgCode: '',
            loading: false,
            tabs: [
                { name: 'image', label: '图片素材', icon: 'ios-image' },
                { name: 'video', label: '视频素材', icon: 'ios-videocam' },
                { name: 'audio', label: '音频素材', icon: 'ios-musical-notes' },
                { name: 'file', label: '文件素材', icon: 'ios-document' }
            ],
            drawerStyles: {
                height: '100%',
                overflow: 'auto',
                paddingBottom: '108px',
                position: 'static'
            },
            uploadForm: {
                fileName: '',
                sourceType: '',
                fileSize: 0,
                filePath: ''
            },
            uploadRules: {
                fileName: [
                    { required: true, message: '请输入文件名称', trigger: 'blur' }
                ],
                sourceType: [
                    { required: true, message: '请选择文件分类', trigger: 'change' }
                ]
            },
            sourceTypeList: [],
            videoThumbnails: {}, // 存储视频缩略图
            materialSource: 'org', // 'org' 或 'platform'，默认为机构素材库
            maxSelectCount: 0, // 最大选择数量，0表示不限制
        }
    },
    computed: {
        uploadHeaders() {
            // 参考 LiefengUpload 的 token 获取方式
            return {
                Authorization: localStorage.getItem('token') || (parent.vue && parent.vue.token) || ''
            }
        }
    },
    watch: {
        fileType: {
            immediate: true,
            handler(val) {
                if(this.fileType){
                    const activeTabs = this.fileType.split(',');
                    this.tabs = this.tabs.filter(tab => activeTabs.includes(tab.name));
                }
               
                if (val) {
                    this.activeTab = val;
                }
            }
        },
        value(val) {
            this.innerVisible = val;
            if (val) {
                this.fetchMaterials(this.activeTab);
            }
        },
        innerVisible(val) {
            if (!val) {
                this.onCancel();
            }
            this.$emit('input', val);
        }
    },
    created() {
        this.fetchSourceTypeList();
    },
    mounted() {
       
    },
    methods: {
        handleCreateCategory(value) {
            this.sourceTypeList.push({
                    value: value,
                    label: value
                });
        },
        debugInfo() {
        },
        open() {
            this.innerVisible = true;
            
            console.log('tabs', this.tabs);
            this.fetchMaterials(this.activeTab);
        },
        fetchMaterials(fileType) {
            const params = {
                groupId: this.groupId,
                fileType: fileType || this.activeTab,
                page: this.page,
                pageSize: this.pageSize
            };
            
            // 如果是机构素材库，添加 orgCode 参数
            if (this.materialSource === 'org' && parent.vue && parent.vue.loginInfo && parent.vue.loginInfo.userinfo) {
                params.orgCode = parent.vue.loginInfo.userinfo.orgCode;
            }
            
            // 如果有搜索关键词，添加搜索参数
            if (this.search && this.search.trim()) {
                params.fileName = this.search.trim();
            }
            
            // 如果有文件分类搜索，添加搜索参数
            if (this.sourceTypeSearch && this.sourceTypeSearch.trim()) {
                params.sourceType = this.sourceTypeSearch.trim();
            }
            
            this.loading = true;
            
            this.$get('/old/api/pc/fileUpload/selectFileUploadPage', params).then(res => {
                this.loading = false;
                console.log('API response:', res);
                if (res.code == 200) {
                    // 处理返回的数据，确保字段名称统一
                    this.materialList = (res.dataList || []).map(item => {
                        return {
                            ...item,
                            fileUrl: item.filePath,
                            filePath: item.filePath,
                            fileId: item.fileId || '',
                            fileName: item.fileName || '未命名文件',
                            fileSize: item.fileSize || 0
                        };
                    });
                    
                    // 更新分页数据
                    this.total = res.maxCount || 0;
                    this.maxPage = res.maxPage || Math.ceil(this.total / this.pageSize) || 1;
                    this.pageSize = res.pageSize || this.pageSize;
                    this.page = res.currentPage || this.page;
                } else {
                    this.$Message.error(res.desc || '获取素材失败');
                }
            }).catch(err => {
                this.loading = false;
                this.$Message.error('网络错误，获取素材失败');
                console.error('API error:', err);
            });
        },
        handleUploadSuccess() {
            console.log('Upload success:');

            const file = this.$refs.liefeng_upload.uploadList[0]

            if (file && file.url) {
                this.uploadForm.filePath = file.url;
                this.uploadForm.fileSize = file.size || 0;
                // 如果文件名为空，使用上传文件的原始名称
                if (!this.uploadForm.fileName) {
                    this.uploadForm.fileName = file.name;
                } else {
                    // 如果用户已经输入了文件名，确保保留原始文件的后缀
                    const originalExt = file.name.split('.').pop();
                    const currentName = this.uploadForm.fileName;
                    if (!currentName.endsWith('.' + originalExt)) {
                        this.uploadForm.fileName = currentName + '.' + originalExt;
                    }
                }
            } else {
                this.$Message.error('上传失败');
            }
        },
        // 保存到素材库
        saveToMaterialLibrary() {
            const params = {
                custGlobalId: parent.vue.custGlobalId,
                fileType: this.activeTab,
                groupId: this.groupId,
                fileName: this.uploadForm.fileName,
                fileSize: this.uploadForm.fileSize,
                filePath: this.uploadForm.filePath,
                sourceType: this.uploadForm.sourceType
            };
            
            // 如果是机构素材库，添加 orgCode 参数
            if (this.materialSource === 'org' && parent.vue && parent.vue.loginInfo && parent.vue.loginInfo.userinfo) {
                params.orgCode = parent.vue.loginInfo.userinfo.orgCode;
            }
            
            console.log('formData:', params);
            
            this.$post('/old/api/pc/fileUpload/saveFileUpload', params)
                .then(res => {
                    if (res.code === 200) {
                        this.$Message.success('上传成功并保存到素材库');
                        this.uploadModalVisible = false;
                        // 刷新素材列表
                        this.fetchMaterials(this.activeTab);
                    } else {
                        this.$Message.error(res.desc || '保存到素材库失败');
                    }
                })
                .catch(err => {
                    this.$Message.error('网络错误，保存到素材库失败');
                    console.error(err);
                });
        },
        previewMaterial(item) {
            this.previewItem = item;
            this.previewVisible = true;
        },
        deleteMaterial(item) {
            this.$Modal.confirm({
                title: '确认删除',
                content: `确定要删除 "${item.fileName}" 吗？`,
                onOk: () => {
                    this.$get('/old/api/pc/fileUpload/deleteFiles', {
                        fileIds: item.fileId
                    }).then(res => {
                        if (res.code === 200) {
                            this.$Message.success('删除成功');
                            // 如果删除的是已选中的项，从选中列表中移除
                            this.selectedItems = this.selectedItems.filter(selected => selected.fileId !== item.fileId);
                            // 刷新素材列表
                            this.fetchMaterials(this.activeTab);
                        } else {
                            this.$Message.error(res.desc || '删除失败');
                        }
                    }).catch(err => {
                        this.$Message.error('网络错误，删除失败');
                    });
                }
            });
        },
        toggleSelect(item) {
            // 确保 selectedItems 是数组
            if (!Array.isArray(this.selectedItems)) {
                this.selectedItems = [];
            }

            // 检查文件类型是否允许选择
            if (this.allowedTypes.length > 0) {
                const fileExt = this.getFileExtension(item.filePath);
                if (!this.allowedTypes.includes(fileExt)) {
                    this.$Message.warning(`只能选择 ${this.allowedTypes.join(', ')} 类型的文件`);
                    return;
                }
            }
            
            // 构建选中项数据
            const selectedItem = {
                fileId: item.fileId,
                fileName: item.fileName,
                fileUrl: item.fileUrl || item.filePath,
                filePath: item.filePath || item.fileUrl,
                fileType: this.getFileExtension(item.filePath),
                fileSize: item.fileSize
            };

            // 直接触发选择事件
            if (this.multiple) {
                // 多选模式
                if (this.isSelected(item)) {
                    // 取消选择
                    this.selectedItems = this.selectedItems.filter(selected => selected.fileId !== item.fileId);
                } else {
                    // 添加选择
                    if (this.maxSelect > 0 && this.selectedItems.length >= this.maxSelect) {
                        this.$Message.warning(`最多只能选择 ${this.maxSelect} 个文件`);
                        return;
                    }
                    this.selectedItems.push(selectedItem);
                }
            } else {
                // 单选模式
                this.selectedItems = [selectedItem];
            }

            // 不再在 toggleSelect 时触发事件
            console.log('Current selected items:', this.selectedItems);
        },
        isSelected(item) {
            if (!Array.isArray(this.selectedItems)) {
                this.selectedItems = [];
                return false;
            }
            return this.selectedItems.some(selected => selected.fileId === item.fileId);
        },
        changePage(page) {
            this.page = page;
            this.fetchMaterials(this.activeTab);
        },
        handleSelectOk() {
            console.log('handleSelectOk', this.selectedItems);
            // 确保 selectedItems 是数组
            if (!Array.isArray(this.selectedItems)) {
                this.selectedItems = [];
            }
            // 触发选择事件，传递选中的数据给父组件
            const selectedData = JSON.parse(JSON.stringify(this.selectedItems));
            console.log('Emitting success event with data:', selectedData);        
            this.$emit('on-select', selectedData); // 添加 on-select 事件
            this.$emit('input', false); // 关闭弹窗
            this.innerVisible = false;
        },
        onCancel() {
            console.log('Handling Cancel');
            this.selectedItems = [];
            this.$emit('on-cancel');
            this.$emit('input', false); // 关闭弹窗
            this.innerVisible = false;
        },
        getCurrentTabLabel() {
            const currentTab = this.tabs.find(tab => tab.name === this.activeTab);
            return currentTab ? currentTab.label.replace('素材', '') : '';
        },
        // 编辑文件名
        editFileName(item) {
            this.editForm = {
                fileId: item.fileId,
                fileName: item.fileName,
                sourceType: item.sourceType || ''
            };
            this.editModalVisible = true;
        },
        // 保存文件名
        saveFileName(item) {
            // 此方法已不再使用，保留空方法以避免引用错误
        },
        // 格式化文件大小
        formatFileSize(size) {
            if (!size) return '';
            
            const units = ['B', 'KB', 'MB', 'GB', 'TB'];
            let fileSize = parseInt(size);
            let unitIndex = 0;
            
            while (fileSize >= 1024 && unitIndex < units.length - 1) {
                fileSize /= 1024;
                unitIndex++;
            }
            
            return `${fileSize.toFixed(2)} ${units[unitIndex]}`;
        },
        changeTab(tabName) {
            console.log('Changing tab to:', tabName);
            this.activeTab = tabName;
            this.page = 1;
            this.search = '';
            this.sourceTypeSearch = ''; // 清空文件分类搜索
            this.fetchSourceTypeList(); // 重新获取文件分类列表
            this.fetchMaterials(tabName);
        },
        // 获取文件图标类型
        getFileIconType(fileName) {
            if (this.isImageFile(fileName)) return 'ios-image';
            if (this.isVideoFile(fileName)) return 'ios-videocam';
            if (this.isAudioFile(fileName)) return 'ios-musical-notes';
            if (this.isPdfFile(fileName)) return 'ios-paper';
            if (this.isOfficeFile(fileName)) return 'ios-document';
            if (this.isCompressedFile(fileName)) return 'ios-archive';
            if (this.isCodeFile(fileName)) return 'ios-code';
            return 'ios-document-outline';
        },
        
        // 判断文件类型的辅助方法
        getFileExtension(fileName) {
            if (!fileName) return '';
            return fileName.split('.').pop().toLowerCase();
        },
        
        isImageFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext);
        },
        
        isVideoFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ['mp4', 'webm', 'ogg', 'mov', 'avi', 'wmv', 'flv', 'mkv'].includes(ext);
        },
        
        isAudioFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a', 'wma'].includes(ext);
        },
        
        isPdfFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ext === 'pdf';
        },
        
        isOfficeFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext);
        },
        
        isCompressedFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ['zip', 'rar', '7z', 'tar', 'gz'].includes(ext);
        },
        
        isCodeFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ['js', 'ts', 'html', 'css', 'json', 'xml', 'java', 'py', 'php', 'c', 'cpp', 'h', 'cs'].includes(ext);
        },
        
        // 获取文件类型标签
        getFileTypeLabel(fileName) {
            if (this.isImageFile(fileName)) return '图片';
            if (this.isVideoFile(fileName)) return '视频';
            if (this.isAudioFile(fileName)) return '音频';
            if (this.isPdfFile(fileName)) return 'PDF';
            if (this.isWordFile(fileName)) return 'Word';
            if (this.isExcelFile(fileName)) return 'Excel';
            if (this.isPptFile(fileName)) return 'PPT';
            if (this.isCompressedFile(fileName)) return '压缩包';
            if (this.isCodeFile(fileName)) return '代码';
            if (this.isTextFile(fileName)) return '文本';
            return '文件';
        },
        
        // 判断更具体的文件类型
        isWordFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ['doc', 'docx'].includes(ext);
        },
        
        isExcelFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ['xls', 'xlsx'].includes(ext);
        },
        
        isPptFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ['ppt', 'pptx'].includes(ext);
        },
        
        isTextFile(fileName) {
            const ext = this.getFileExtension(fileName);
            return ['txt', 'md', 'rtf'].includes(ext);
        },
        
        // 下载文件
        downloadMaterial(item) {
            if (!item) return;
            
            const url = item.fileUrl || item.filePath;
            if (!url) {
                this.$Message.error('文件链接不存在，无法下载');
                return;
            }
            
            try {
                // 构建下载文件名
                let downloadFileName = item.fileName;
                const filePathExt = this.getFileExtension(url);
                const fileNameExt = this.getFileExtension(item.fileName);
                
                // 如果 fileName 没有后缀，或者后缀与 filePath 不一致，使用 filePath 的后缀
                if (!fileNameExt || fileNameExt !== filePathExt) {
                    // 如果 fileName 已经有后缀，先移除
                    if (fileNameExt) {
                        downloadFileName = item.fileName.slice(0, -(fileNameExt.length + 1));
                    }
                    downloadFileName = downloadFileName + '.' + filePathExt;
                }
                
                // 使用XMLHttpRequest下载文件，避免打开新页面
                const xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';
                
                const that = this;
                
                xhr.onload = function() {
                    if (this.status === 200) {
                        const blob = new Blob([this.response]);
                        const blobUrl = window.URL.createObjectURL(blob);
                        
                        const link = document.createElement('a');
                        link.href = blobUrl;
                        link.download = downloadFileName;
                        link.style.display = 'none';
                        
                        document.body.appendChild(link);
                        link.click();
                        
                        // 清理
                        setTimeout(() => {
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(blobUrl);
                        }, 100);
                    } else {
                        console.error('下载文件失败，状态码:', this.status);
                        that.$Message.error('下载文件失败');
                    }
                };
                
                xhr.onerror = function() {
                    console.error('下载文件出错');
                    that.$Message.error('下载文件失败');
                };
                
                xhr.send();
                this.$Message.success('开始下载文件');
            } catch (error) {
                console.error('下载文件出错:', error);
                this.$Message.error('下载文件失败');
            }
        },
        getFormatByActiveTab() {
            switch (this.activeTab) {
                case 'image':
                    return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
                case 'video':
                    return ['mp4', 'webm', 'ogg', 'mov', 'avi', 'wmv', 'flv', 'mkv'];
                case 'audio':
                    return ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a', 'wma'];
                default:
                    return [];
            }
        },
        getAcceptByActiveTab() {
            switch (this.activeTab) {
                case 'image':
                    return '.jpg,.jpeg,.png,.gif,.bmp,.webp,.svg';
                case 'video':
                    return '.mp4,.webm,.ogg,.mov,.avi,.wmv,.flv,.mkv';
                case 'audio':
                    return '.mp3,.wav,.ogg,.aac,.flac,.m4a,.wma';
                default:
                    return '';
            }
        },
        // 打开上传弹窗
        openUploadModal() {
            this.uploadModalVisible = true;
            this.resetUploadForm();
            this.fetchSourceTypeList();
        },
        
        // 重置上传表单
        resetUploadForm() {
            this.uploadForm = {
                fileName: '',
                sourceType: '',
                fileSize: 0,
                filePath: ''
            };
            if (this.$refs.uploadForm) {
                this.$refs.uploadForm.resetFields();
            }
        },
        
        // 获取文件分类列表
        fetchSourceTypeList() {
            const params = {
                groupId: this.groupId,
                fileType: this.activeTab
            };
            
            this.$get('/old/api/app/fileUpload/selectFileUploadSourceType', params)
                .then(res => {
                    if (res.code == 200) {
                        // 保留现有的自定义分类
                        const customTypes = this.sourceTypeList.filter(item => 
                            !res.dataList.includes(item.value)
                        );
                        
                        this.sourceTypeList = [
                            ...customTypes,
                            ...(res.dataList || []).filter(item => item).map(item => ({
                                value: item,
                                label: item
                            }))
                        ];
                    } else {
                        this.$Message.error(res.desc || '获取文件分类失败');
                    }
                })
                .catch(err => {
                    this.$Message.error('网络错误，获取文件分类失败');
                    console.error(err);
                });
        },
        
        // 处理上传弹窗确认
        handleUploadOk() {
            this.$refs.uploadForm.validate((valid) => {
                if (valid) {
                    // 验证文件名是否包含后缀
                    const fileName = this.uploadForm.fileName;

                    // 确保分类存在于列表中
                    if (this.uploadForm.sourceType && !this.sourceTypeList.some(item => item.value === this.uploadForm.sourceType)) {
                        this.sourceTypeList.push({
                            value: this.uploadForm.sourceType,
                            label: this.uploadForm.sourceType
                        });
                    }

                    this.saveToMaterialLibrary();
                }
            });
        },
        
        // 处理上传弹窗取消
        handleUploadCancel() {
            this.resetUploadForm();
            this.uploadModalVisible = false;
        },
        
        // 获取视频缩略图
        getVideoThumbnail(videoUrl) {
            // 如果已经有缩略图，直接返回
            if (this.videoThumbnails[videoUrl]) {
                return this.videoThumbnails[videoUrl];
            }
            
            // 创建一个临时的 video 元素来获取第一帧
            const video = document.createElement('video');
            video.src = videoUrl;
            video.crossOrigin = 'anonymous';
            video.preload = 'metadata';
            
            // 设置视频加载到第一帧
            video.currentTime = 0.1;
            
            // 当视频加载到第一帧时，将其转换为图片
            video.onseeked = () => {
                const canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                
                // 将 canvas 转换为图片 URL
                const thumbnailUrl = canvas.toDataURL('image/jpeg');
                this.$set(this.videoThumbnails, videoUrl, thumbnailUrl);
                
                // 清理资源
                video.pause();
                video.src = '';
                video.load();
            };
            
            // 如果视频加载失败，使用默认图片
            video.onerror = () => {
                // 使用内联的 SVG 作为默认占位图
                const defaultThumbnail = `data:image/svg+xml,${encodeURIComponent(`
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#515a6e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M23 7l-7 5 7 5V7z"/>
                        <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
                    </svg>
                `)}`;
                this.$set(this.videoThumbnails, videoUrl, defaultThumbnail);
            };
            
            // 返回默认占位图
            return `data:image/svg+xml,${encodeURIComponent(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#515a6e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M23 7l-7 5 7 5V7z"/>
                    <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
                </svg>
            `)}`;
        },
        // 处理编辑弹窗确认
        handleEditOk() {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    // 验证文件名是否包含后缀
                    const fileName = this.editForm.fileName;
                  
                    // 确保分类存在于列表中
                    if (this.editForm.sourceType && !this.sourceTypeList.some(item => item.value === this.editForm.sourceType)) {
                        this.sourceTypeList.push({
                            value: this.editForm.sourceType,
                            label: this.editForm.sourceType
                        });
                    }
                    
                    // 调用接口更新文件信息
                    this.$post('/old/api/pc/fileUpload/saveFileUpload', {
                        fileId: this.editForm.fileId,
                        fileName: this.editForm.fileName,
                        sourceType: this.editForm.sourceType
                    }).then(res => {
                        if (res.code == 200) {
                            this.$Message.success('文件信息修改成功');
                            this.editModalVisible = false;
                            // 刷新素材列表
                            this.fetchMaterials(this.activeTab);
                        } else {
                            this.$Message.error(res.desc || '文件信息修改失败');
                        }
                    }).catch(err => {
                        this.$Message.error('网络错误，文件信息修改失败');
                        console.error(err);
                    });
                }
            });
        },

        // 添加编辑弹窗取消方法
        handleEditCancel() {
            this.editModalVisible = false;
            this.$refs.editForm.resetFields();
        },

        // 处理素材库切换
        handleSourceChange(value) {
            this.materialSource = value;
            this.page = 1;
            this.search = '';
            this.sourceTypeSearch = '';
            this.selectedItems = [];
            this.fetchMaterials(this.activeTab);
        },
    }
}
</script>

<style lang="less" scoped>
.material-container {
    display: flex;
    height: calc(100vh - 120px);
    width: 100%;
    overflow: hidden; // 防止整体出现滚动条
}

.category-sidebar {
    width: 200px;
    border-right: 1px solid #e8eaec;
    background-color: #f8f8f9;
    padding: 16px 0;
    flex-shrink: 0;
    overflow-y: auto;
    height: 100%;
}

.content-area {
    flex: 1;
    padding: 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden; // 防止内容区域出现双滚动条
}

.drawer-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #e8eaec;
    padding: 10px 16px;
    background: #fff;
    text-align: right;
}

.category-header {
    padding: 0 16px 16px;
    border-bottom: 1px solid #e8eaec;
    margin-bottom: 16px;

    h3 {
        margin: 0;
        font-size: 16px;
        color: #17233d;
    }
}

.category-list {
    .category-item {
        padding: 12px 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
        transition: all 0.2s ease;
        color: #515a6e;

        &:hover {
            background-color: #e8eaec;
            color: #2d8cf0;
        }

        &.active {
            background-color: #2d8cf0;
            color: #fff;
        }

        i {
            margin-right: 8px;
            font-size: 18px;
        }
    }
}

.filter-bar {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.material-content {
    position: relative;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.material-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 16px;
    margin-bottom: 20px;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    padding-right: 8px;
    transition: opacity 0.3s ease;
    
    &.is-loading {
        opacity: 0.6;
        pointer-events: none;
    }
}

.material-item {
    position: relative;
    border: 1px solid #e8eaec;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: #fff;
    width: 100%;
    height: 220px; // 固定高度
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.material-preview {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f8f9;
    overflow: hidden;
    position: relative;
    min-height: 0;
    height: 120px;

    .material-checkbox {
        position: absolute;
        top: 8px;
        right: 8px;
        z-index: 3;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 50%;
        padding: 2px;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        
        .ivu-checkbox-wrapper {
            margin-right: 0;
            
            .ivu-checkbox {
                margin-right: 0;
                
                .ivu-checkbox-inner {
                    border-radius: 50%;
                    width: 16px;
                    height: 16px;
                    
                    &:after {
                        width: 4px;
                        height: 8px;
                    }
                }
            }
        }
    }
    
    .file-type-tag {
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: rgba(45, 140, 240, 0.8);
        color: #fff;
        padding: 2px 6px;
        font-size: 12px;
        border-top-left-radius: 4px;
        z-index: 1;
    }

    .source-type-tag {
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(82, 196, 26, 0.8);
        color: #fff;
        padding: 2px 6px;
        font-size: 12px;
        border-bottom-right-radius: 4px;
        z-index: 1;
        max-width: 120px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.material-info {
    padding: 8px;
    background-color: #fff;
    position: relative;
    height: 80px; // 增大高度
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 0;
}

.material-name {
    margin: 0;
    font-size: 12px;
    line-height: 1.5;
    white-space: normal; // 允许换行
    max-height: 36px;    // 最多两行
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    color: #515a6e;
}

.material-action {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    flex-shrink: 0;
    
    i {
        font-size: 16px;
        color: #515a6e;
        cursor: pointer;
        
        &:hover {
            color: #2d8cf0;
        }
    }
}

.material-size {
    font-size: 11px;
    color: #999;
    margin-top: 2px;
    flex-shrink: 0;
}

.material-empty {
    width: 100%;
    padding: 30px;
    text-align: center;
    color: #999;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    background: #fff;
    border-radius: 4px;
    margin: 20px 0;
}

.pagination {
    margin-top: 20px;
    text-align: right;
    flex-shrink: 0;
    padding: 10px 0;
    background: #fff;
}

/* 修改名称输入框样式 */
.material-info .ivu-input-wrapper {
    width: 100%;
    margin-bottom: 8px;
}

.material-info .ivu-input {
    padding: 2px 4px;
    height: 24px;
}

.loading-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    background: transparent;
    white-space: nowrap;
    text-align: center;
    
    .spin-icon-load {
        animation: ani-spin 1s linear infinite;
    }
    
    .loading-text {
        margin-top: 8px;
        font-size: 14px;
        color: #2d8cf0;
        white-space: nowrap;
    }
}

@keyframes ani-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* 预览模态框样式 */
.preview-modal {
    :deep(.ivu-modal) {
        top: 0;
        padding-bottom: 0;
        height: 100vh;
    }
    
    :deep(.ivu-modal-content) {
        height: 100vh;
        border-radius: 0;
    }
    
    :deep(.ivu-modal-header) {
        padding: 16px 24px;
        border-bottom: 1px solid #e8eaec;
        background: #fff;
    }
    
    :deep(.ivu-modal-body) {
        padding: 0;
        height: calc(100vh - 57px);
        overflow: hidden;
    }
}

.preview-container {
    width: 100%;
    height: calc(100vh - 57px);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f8f8f9;
    
    img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }
    
    video {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }
    
    iframe {
        width: 100%;
        height: 100%;
        border: none;
    }
}

.audio-preview-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    
    i {
        margin-bottom: 20px;
        color: #2d8cf0;
        font-size: 80px;
    }
    
    audio {
        width: 600px;
    }
}

.office-preview, .no-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
    
    i {
        margin-bottom: 20px;
        color: #515a6e;
        font-size: 80px;
    }
    
    p {
        margin-bottom: 20px;
        color: #515a6e;
        font-size: 16px;
    }
    
    .ivu-btn {
        padding: 8px 24px;
        font-size: 16px;
    }
}

/* 上传弹窗样式 */
.upload-container {
    padding: 20px;
    
    .ivu-form {
        .ivu-form-item {
            margin-bottom: 24px;
            
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}

.video-preview {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    
    .video-play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        transition: all 0.3s ease;
        
        &:hover {
            background-color: rgba(0, 0, 0, 0.7);
            transform: translate(-50%, -50%) scale(1.1);
        }
    }
}

.material-source-switch {
    padding: 16px;
    border-bottom: 1px solid #e8eaec;
    margin-bottom: 16px;
    
    .ivu-radio-group-button {
        width: 100%;
        display: flex;
        
        .ivu-radio-wrapper {
            flex: 1;
            text-align: center;
            padding: 8px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 36px;
            
            i {
                margin-right: 4px;
                font-size: 16px;
            }
            
            span {
                font-size: 14px;
            }
        }
    }
}

// 优化滚动条样式
.material-list::-webkit-scrollbar {
    width: 6px;
}

.material-list::-webkit-scrollbar-thumb {
    background-color: #dcdee2;
    border-radius: 3px;
}

.material-list::-webkit-scrollbar-track {
    background-color: #f8f8f9;
}
</style> 